export default __webpack_public_path__ + "static/media/bg-planet-icon.45e584d8.png";